// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "body[data-service-layer-open=true]{background:#bed7aa!important;transition:background 0s .35s}body[data-green-bg=true]{background:#bed7aa!important}body[data-is-transitioning=true]{transition:background .35s ease}.page-enter-active,.page-leave-active{transition:opacity .275s}.page-enter{opacity:.01}.page-leave-active{opacity:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
